import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Accordion from '../../shared/Accordion';
import AccordionItem from '../../shared/AccordionItem';
import accordionFaqTheme from '../../shared/Accordion-faq.module.postcss';

import styles from './Faq.module.postcss';

function Faq({ questions }) {

  const metaJSON = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: []
  };

  const questionsList = questions.map((q, i) => {
    metaJSON.mainEntity.push({
      '@type': 'Question',
      name: q.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: `<p>${q.answer}</p>`
      }
    });
    return <AccordionItem key={'question-' + i} title={q.question}>{ q.answer }</AccordionItem>;
  });

  return (
    <div className={styles.Faq}>
      <h2 className='u-textCenter'>Frequently Asked Questions</h2>

      <div className={styles.Faq_content}>
        <Accordion theme={accordionFaqTheme}>
          {questionsList}
        </Accordion>
      </div>

      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(metaJSON)}
        </script>
      </Helmet>
    </div>
  );
}

Faq.propTypes = {
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      fontSize: PropTypes.number
    })
  ).isRequired,
};

export default Faq;
